const hasAnyRequiredRole = (roles: string[] | undefined, requiredRoles: string[]): boolean => {
	if (typeof roles === 'undefined') return false;
	return roles.some((role) => requiredRoles.includes(role));
};

export default hasAnyRequiredRole;
